var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 132,
    viewBox: "0 0 107 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.2771 111.684H5.06604V131.997H101.405V111.684H91.2609H91.2771ZM96.3493 121.841V126.919H10.1382V116.763H96.3493V121.841Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.423 10.1578V15.236V20.3141V25.3923V30.4543V35.5324V40.6106V45.6888V50.7669V55.8451V60.9233V66.0015V71.0796V76.1578V81.236V86.3141V91.3761V96.4543V101.532V106.611V111.689H106.479V106.611V101.532V96.4543V91.3761V86.3141V81.236V76.1578V71.0796V66.0015V60.9233V55.8451V50.7669V45.6888V40.6106V35.5324V30.4543V25.3923V20.3141V15.236V10.1578H101.423Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.43 5.07892H96.3574V10.1571H101.43V5.07892Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2892 5.07817H25.3614H30.4336H35.5058H40.5781H45.6502H50.7062H55.7784H60.8506H65.9228H70.995H76.0672H81.1394H86.2116H91.2838H96.356V0H91.2838H86.2116H81.1394H76.0672H70.995H65.9228H60.8506H55.7784H50.7062H45.6502H40.5781H35.5058H30.4336H25.3614H20.2892H15.217H10.1449V5.07817H15.217H20.2892Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1382 5.07892H5.06604V10.1571H10.1382V5.07892Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.0722 101.532V96.4543V91.3761V86.3141V81.236V76.1578V71.0796V66.0015V60.9233V55.8451V50.7669V45.6888V40.6106V35.5324V30.4543V25.3923V20.3141V15.236V10.1578H0V15.236V20.3141V25.3923V30.4543V35.5324V40.6106V45.6888V50.7669V55.8451V60.9233V66.0015V71.0796V76.1578V81.236V86.3141V91.3761V96.4543V101.532V106.611V111.689H5.0722V106.611V101.532Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2109 91.3752V96.4534H20.2831H25.3553V91.3752H20.2831H15.2109Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1393 91.3752H76.0671H70.9949H65.9227V96.4534H70.9949H76.0671H81.1393H86.2115H91.2837V91.3752H86.2115H81.1393Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2125 20.3149V25.3931V30.455V35.5332V40.6114V45.6895V50.7677V55.8459V60.924V66.0022H91.2847V60.924V55.8459V50.7677V45.6895V40.6114V35.5332V30.455V25.3931V20.3149V15.2367H86.2125V20.3149Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4343 15.236H35.5065H40.5787H45.6508H50.7068H55.779H60.8512H65.9234H70.9956H76.0678H81.14H86.2122V10.1578H81.14H76.0678H70.9956H65.9234H60.8512H55.779H50.7068H45.6508H40.5787H35.5065H30.4343H25.3621H20.2899V15.236H25.3621H30.4343Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2831 55.8459V50.7677V45.6895V40.6114V35.5332V30.455V25.3931V20.3149V15.2367H15.2109V20.3149V25.3931V30.455V35.5332V40.6114V45.6895V50.7677V55.8459V60.924V66.0022H20.2831V60.924V55.8459Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0678 66H70.9956H65.9234H60.8512H55.779H50.7068H45.6508H40.5787H35.5065H30.4343H25.3621H20.2899V71.0782H25.3621H30.4343H35.5065H40.5787H45.6508H50.7068H55.779H60.8512H65.9234H70.9956H76.0678H81.14H86.2122V66H81.14H76.0678Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0469 29.2577H53.2508V27.0512H51.0469H48.843H46.6391V29.2577H48.843H51.0469Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M55.4559 29.2555H53.252V31.462H55.4559V29.2555Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6602 31.4662H55.4563V33.6727H57.6602V31.4662Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6606 38.0835V40.29H59.8645V38.0835V35.877V33.6705H57.6606V35.877V38.0835Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6597 40.2963H55.4559V42.5028H53.252V44.7093H55.4559H57.6597V42.5028V40.2963Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M48.843 44.6985H46.6391V46.9049H48.843H51.0469H53.2508V44.6985H51.0469H48.843Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6387 42.4941H44.4348V44.7006H46.6387V42.4941Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4215 40.2963H42.2176V42.5028H44.4215V40.2963Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2172 35.877V33.6705H40.0133V35.877V38.0835V40.29H42.2172V38.0835V35.877Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4215 31.4662H42.2176V33.6727H44.4215V31.4662Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6387 29.2555H44.4348V31.462H46.6387V29.2555Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6387 35.8813H44.4348V38.0877H46.6387V35.8813Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M48.843 38.0855H46.6391V40.292H48.843V38.0855Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0473 40.2963H48.8434V42.5028H51.0473V40.2963Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2723 49.1114V46.9049H62.0684V44.6985H59.8645H57.6606V46.9049V49.1114H59.8645V51.3179H62.0684V53.5406H64.2723H66.4762V51.3179V49.1114H64.2723Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyData);
export default __webpack_public_path__ + "static/media/empty_data.f1501109.svg";
export { ForwardRef as ReactComponent };